import { Component, forwardRef, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { setupCkeditorPersistTextColor } from "src/app/core/utils/ckeditor-persist-text-color.util";
import { injectCountryFlagEmojiPolyfill } from "src/app/core/utils/country-flag-emoji-polyfill.util";
import { getPlainTextLength, isRichTextTooLong } from "../rich-text.utils";

@Component({
  selector: "app-travel-kit-rich-text-editor",
  templateUrl: "./travel-kit-rich-text-editor.component.html",
  styleUrls: ["./travel-kit-rich-text-editor.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TravelKitRichTextEditorComponent),
      multi: true,
    },
  ],
})
export class TravelKitRichTextEditorComponent implements ControlValueAccessor {
  @Input() maxLength = 5000;
  @Input() isInvalid = false;

  value = "";
  disabled = false;
  config: any = {};

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  constructor() {
    this.config = {
      versionCheck: false,
      toolbar: [
        { name: "links", items: ["Link", "Unlink", "Anchor"] },
        { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "-", "TextColor", "BGColor"] },
        { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
        { name: "styles", items: ["FontSize"] },
      ],
      removeButtons:
        "Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Format,Font,Styles,CopyFormatting,RemoveFormat,Subscript,Superscript,Table,Image",
      removePlugins: "sourcearea,specialchar,horizontalrule,elementspath,resize",
      removeDialogTabs: "image:advanced;link:advanced",
      contentsCss: [
        "https://cdn.ckeditor.com/4.22.1/full/contents.css",
        "/assets/css/ckeditor-emoji.css",
      ],
      on: {
        instanceReady: (event: { editor: { document: { $: Document } } }) => {
          injectCountryFlagEmojiPolyfill(event.editor.document.$);
          setupCkeditorPersistTextColor(event.editor);
        },
      },
    };
  }

  get plainTextLength(): number {
    return getPlainTextLength(this.value);
  }

  get isTooLong(): boolean {
    return isRichTextTooLong(this.value, this.maxLength);
  }

  writeValue(value: string): void {
    this.value = value || "";
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onEditorChange(value: string): void {
    this.value = value || "";
    this.onChange(this.value);
  }

  onEditorBlur(): void {
    this.onTouched();
  }
}
